import { Accordion } from './Accordion';
import { AccordionBody } from './AccordionBody';
import { AccordionHeader } from './AccordionHeader';
import { AccordionIndicator } from './AccordionIndicator';

Accordion.Body = AccordionBody;
Accordion.Header = AccordionHeader;
Accordion.Indicator = AccordionIndicator;

export default Accordion;
